import { AnalyticsContextValue, NotAvailable } from '@ui-common/analytics'
import { useSendPageViewEvent } from '@ui-common/hooks'
import { getLanguage, getSourceChannel } from '@ui-common/utils'
import { createContext, PropsWithChildren, use, useMemo } from 'react'

import { WizardStep } from '../wizard/wizardMachine'
import { getAnalyticsNameForPage, LoanOfferAnalyticsService } from './service'

type AnalyticsContext = AnalyticsContextValue<LoanOfferAnalyticsService>

export const LoanOfferAnalyticsContext = createContext<AnalyticsContext>({
  analyticsService: new LoanOfferAnalyticsService(),
})

export const LoanOfferAnalyticsProvider = ({ children }: PropsWithChildren) => {
  const analyticsProviderValue = useMemo(
    () => ({
      analyticsService: new LoanOfferAnalyticsService({
        flow: NotAvailable,
        product: NotAvailable,
        src: getSourceChannel() ?? NotAvailable,
        ui_lang: getLanguage(),
        version: import.meta.env.VITE_APP_VERSION ?? NotAvailable,
      }),
    }),
    [],
  )

  return <LoanOfferAnalyticsContext value={analyticsProviderValue}>{children}</LoanOfferAnalyticsContext>
}

export const useLoanOfferAnalyticsService = () => {
  const context = use(LoanOfferAnalyticsContext)

  if (context === undefined) {
    throw new Error('useLoanOfferAnalyticsService must be used within a LoanOfferAnalyticsProvider')
  }

  return context
}

export const useLoanOfferPageViewEvent = (step: WizardStep): void => {
  const { analyticsService } = useLoanOfferAnalyticsService()
  useSendPageViewEvent(analyticsService, getAnalyticsNameForPage(step))
}
